import { getIds } from 'hooks'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import type { Item } from 'typings'
import { useFormStateContext } from '../../../../providers'
import {
  CancelButton,
  DismissButton,
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerSubtitle,
  DrawerTitle,
  SaveButton,
  UseDrawerStateReturn,
} from '../../../Drawer'
import { ListSelector } from '../../../ListSelector'
import { messages } from './messages'

type PaymentMethodsProps = {
  name: string
  state: UseDrawerStateReturn
  options: Item[] | undefined
  loading: boolean
}

export function PaymentMethodsEditor(props: PaymentMethodsProps) {
  const { name, state: drawerState, options, loading } = props

  const { formatMessage: i18n } = useIntl()

  const { form } = useFormStateContext()
  const initialValues: Item[] | undefined = form.getValues(name)
  const isCreating = initialValues === undefined || initialValues.length === 0

  const [editorValues, setEditorValues] = useState<string[]>(
    getIds(initialValues)
  )

  const handleSave = () => {
    const newValues = editorValues.length
      ? editorValues.map((id) => options?.find((option) => option.id === id))
      : undefined

    form.setValue(name, newValues)

    drawerState.hide()
  }

  useEffect(() => {
    drawerState.open && setEditorValues(getIds(initialValues))
  }, [drawerState.open, initialValues])

  return (
    <Drawer state={drawerState}>
      <DrawerHeader>
        <DrawerTitle>{i18n(messages.title)}</DrawerTitle>
        <DrawerSubtitle>{i18n(messages.subtitle)}</DrawerSubtitle>
        <DismissButton onHide={drawerState.hide} />
      </DrawerHeader>
      <DrawerContent>
        <ListSelector
          values={editorValues}
          onChange={setEditorValues}
          loading={loading}
          options={options}
        />
      </DrawerContent>
      <DrawerFooter>
        <CancelButton onClick={drawerState.hide} />
        <SaveButton isCreating={isCreating} onClick={handleSave} />
      </DrawerFooter>
    </Drawer>
  )
}
